export default __webpack_public_path__ + "static/InBin-04486515eaf5cbb2a8ad1d15a7f861d1.jpg";